// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__DVp4D","content":"GlobalSearch_content__G-rv_"};